import { useTranslation } from 'react-i18next';

import { UsersPanel } from './users-panel';
import { ErrorPage } from '../../../components/error-page';
import { LoadingScreen } from '../../../components/loading-screen';
import { useCurrentUser } from '../../hooks/current-user';
import { useUserPermissions } from '../../hooks/user-permissions';

import accessDeniedOperatorImage from '../../../assets/access-denied-operator.svg';

export function UsersPage() {
  const { loading } = useCurrentUser();
  const { isAccessToUserPageAllowed } = useUserPermissions();
  const { t } = useTranslation();

  if (loading) return <LoadingScreen />;

  if (!isAccessToUserPageAllowed) {
    return (
      <ErrorPage
        data-testid="access-denied"
        title={t('common.accessDenied.title')}
        subTitle={t('common.accessDenied.subTitle')}
        image={accessDeniedOperatorImage}
        style={{ gridArea: 'section', height: 'unset', background: 'none' }}
      />
    );
  }

  return <UsersPanel />;
}
